export default "__VITE_ASSET__BKfTgwua__"